// extracted by mini-css-extract-plugin
export var monthFull = "EventCard-module--monthFull--05aac";
export var size_lg = "EventCard-module--size_lg--44683";
export var size_lg_condenced = "EventCard-module--size_lg_condenced--8c71d";
export var size_md = "EventCard-module--size_md--81f37";
export var size_sm = "EventCard-module--size_sm--64f8e";
export var text = "EventCard-module--text--4deea";
export var upcomingDate = "EventCard-module--upcomingDate--6a31b";
export var upcomingDateBig = "EventCard-module--upcomingDateBig--bebdd";
export var upcomingDateDay = "EventCard-module--upcomingDateDay--97d01";
export var upcomingDateMonth = "EventCard-module--upcomingDateMonth--9bb9a";
export var upcomingDateSmall = "EventCard-module--upcomingDateSmall--97137";
export var upcomingDateWrapper = "EventCard-module--upcomingDateWrapper--68515";
export var withImage = "EventCard-module--withImage--66c33";